import styled from 'styled-components';
import { jsxs, jsx } from 'react/jsx-runtime';
import PropTypes from 'prop-types';
import { formatSwedishPostcode } from '@eir/utils';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var _templateObject$4, _templateObject2$2;
var PageContainer = styled.div(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n  display: flex;\n  height: 79.5rem;\n  flex-direction: column;\n  border: 1px solid #dedede;\n  padding: 2rem;\n  margin-bottom: 0.5rem;\n  box-shadow: 0 0.125rem 0.62rem rgba(0, 0, 0, 0.3);\n  background-color: #fff;\n\n  @media print {\n    width: 197.3mm;\n    height: 276.19mm;\n    border: 0;\n    padding: 0 13.65mm;\n    margin-bottom: 0;\n    box-shadow: none;\n  }\n"])));
var PageContent = styled.div(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n  flex: 1;\n"])));

var Page = function Page(_ref) {
  var pageHeader = _ref.pageHeader,
      pageFooter = _ref.pageFooter,
      content = _ref.content;
  return /*#__PURE__*/jsxs(PageContainer, {
    children: [pageHeader, /*#__PURE__*/jsx(PageContent, {
      children: content
    }), pageFooter]
  });
};

var _templateObject$3;
var Wrapper = styled.div(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n  width: 56.25rem;\n  margin: 1.875rem auto;\n\n  @media print {\n    margin: 0;\n    width: 100%;\n  }\n"])));

var PageWrapper = function PageWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/jsx(Wrapper, {
    children: children
  });
};

var _templateObject$2, _templateObject2$1, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15;

var LetterContainer = styled.div(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  width: 100%;\n  max-width: 56.25rem;\n  margin: 1.875rem auto;\n  line-height: 1.7;\n  -webkit-font-smoothing: antialiased;\n  text-rendering: optimizeLegibility;\n\n  main {\n    padding: 0 0.625rem;\n\n    @media (min-width: 48rem) {\n      padding: 0 1.875rem;\n    }\n  }\n"])));
var HeaderContainer = styled.header(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n  margin: auto;\n  padding: 0 1.875rem;\n"])));
var ItemContainer = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  font-weight: 700;\n\n  &:last-child {\n    border: 0;\n  }\n\n  span {\n    font-size: 0.8rem;\n  }\n"])));
var LetterSection = styled.section(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  padding: 0.5rem;\n  margin: 1rem 0;\n  background-color: ", ";\n  border: 0.0625rem solid\n    ", ";\n  border-radius: ", ";\n\n  @media (min-width: 48rem) {\n    padding: 0.5rem 1.5625rem;\n  }\n"])), function (props) {
  return props.backroundColor ? props.backroundColor : '#fafafa';
}, function (props) {
  return props.borderColor ? props.borderColor : '#dadada';
}, function (props) {
  return props.borderRadius ? props.borderRadius : '0.313rem';
}); // Text and headings

var H1 = styled.h1(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: 1.5rem;\n  margin-bottom: 0.5rem;\n\n  @media (min-width: 30rem) {\n    font-size: 2.2rem;\n  }\n\n  @media (min-width: 48rem) {\n    font-size: 2.5rem;\n  }\n"])));
var H2 = styled.h2(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-size: 1.3rem;\n\n  @media (min-width: 30rem) {\n    font-size: 1.7rem;\n  }\n\n  @media (min-width: 48rem) {\n    font-size: 1.9rem;\n  }\n"])));
var H3 = styled.h3(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-size: 1.1rem;\n\n  @media (min-width: 30rem) {\n    font-size: 1.5rem;\n  }\n"])));
var DisclaimerText = styled.p(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  margin: 1rem 0;\n  font-size: 0.8125rem;\n  color: #7b7d8c;\n"])));
var IntroText = styled.p(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  line-height: 1.2rem;\n  margin-top: 0.625rem;\n"])));
var LabelText = styled.p(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  font-weight: 400;\n"])));
var ValueText = styled.p(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  text-align: right;\n"]))); // Image and logoSrc

var LogoWrapper = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  gap: 4rem;\n  margin-bottom: 2rem;\n"])));
var Logo = styled.img(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  width: auto;\n  height: 3.5rem;\n\n  @media (min-width: 30rem) {\n    height: 4.5rem;\n  }\n"]))); // Tables

var ContentTable = styled.table(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  width: 100%;\n  text-align: left;\n\n  td {\n    font-size: 0.75rem;\n    border-top: 0.0625rem solid #e5e5e8;\n    padding: 0.625rem 0;\n    word-break: break-word;\n\n    &:first-child {\n      min-width: auto;\n    }\n\n    &:nth-child(2) {\n      min-width: auto;\n    }\n\n    @media (min-width: 48rem) {\n      font-size: 0.9375rem;\n    }\n  }\n\n  th {\n    font-size: 0.875rem;\n  }\n"])));
var TableHeader = styled.th(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  min-width: 100px;\n"])));

var styles = /*#__PURE__*/Object.freeze({
  __proto__: null,
  LetterContainer: LetterContainer,
  HeaderContainer: HeaderContainer,
  ItemContainer: ItemContainer,
  LetterSection: LetterSection,
  H1: H1,
  H2: H2,
  H3: H3,
  DisclaimerText: DisclaimerText,
  IntroText: IntroText,
  LabelText: LabelText,
  ValueText: ValueText,
  LogoWrapper: LogoWrapper,
  Logo: Logo,
  ContentTable: ContentTable,
  TableHeader: TableHeader
});

var Header = function Header(_ref) {
  var children = _ref.children,
      logoSrc = _ref.logoSrc;
  return /*#__PURE__*/jsxs(HeaderContainer, {
    children: [/*#__PURE__*/jsx(LogoWrapper, {
      children: logoSrc.map(function (logo) {
        return /*#__PURE__*/jsx(Logo, {
          src: logo
        });
      })
    }), children]
  });
};

Header.propTypes = {
  children: PropTypes.node.isRequired,
  logoSrc: PropTypes.arrayOf(PropTypes.string)
};

var _templateObject$1, _templateObject2;

var PaymentSchedule = function PaymentSchedule(_ref) {
  var _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? '#fafafa' : _ref$backgroundColor,
      _ref$borderColor = _ref.borderColor,
      borderColor = _ref$borderColor === void 0 ? '#dadada' : _ref$borderColor,
      _ref$borderRadius = _ref.borderRadius,
      borderRadius = _ref$borderRadius === void 0 ? '0.313rem' : _ref$borderRadius,
      heading = _ref.heading,
      _ref$tableHeader = _ref.tableHeader1,
      tableHeader1 = _ref$tableHeader === void 0 ? 'Nummer' : _ref$tableHeader,
      _ref$tableHeader2 = _ref.tableHeader2,
      tableHeader2 = _ref$tableHeader2 === void 0 ? 'Betald' : _ref$tableHeader2,
      _ref$tableHeader3 = _ref.tableHeader3,
      tableHeader3 = _ref$tableHeader3 === void 0 ? 'Dag' : _ref$tableHeader3,
      _ref$tableHeader4 = _ref.tableHeader4,
      tableHeader4 = _ref$tableHeader4 === void 0 ? 'Belopp' : _ref$tableHeader4,
      paymentSchedule = _ref.paymentSchedule;
  return /*#__PURE__*/jsxs(TableSection, {
    backgroundColor: backgroundColor,
    borderColor: borderColor,
    borderRadius: borderRadius,
    children: [/*#__PURE__*/jsx(H2, {
      children: heading
    }), /*#__PURE__*/jsxs(Table, {
      children: [/*#__PURE__*/jsx("thead", {
        children: /*#__PURE__*/jsxs("tr", {
          children: [/*#__PURE__*/jsx("th", {
            children: tableHeader1
          }), /*#__PURE__*/jsx("th", {
            children: tableHeader2
          }), /*#__PURE__*/jsx("th", {
            children: tableHeader3
          }), /*#__PURE__*/jsx("th", {
            children: tableHeader4
          })]
        })
      }), /*#__PURE__*/jsx("tbody", {
        children: paymentSchedule.map(function (payment) {
          return /*#__PURE__*/jsxs("tr", {
            children: [/*#__PURE__*/jsx("td", {
              children: payment.index
            }), /*#__PURE__*/jsx("td", {
              children: payment.status === 'Collected' || payment.collected === true ? 'Ja' : '-'
            }), /*#__PURE__*/jsx("td", {
              children: payment.collectionDay
            }), /*#__PURE__*/jsxs("td", {
              children: [payment.amount.toLocaleString('sv-SE', {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2
              }), ' ', "kr"]
            })]
          }, payment.index);
        })
      })]
    })]
  });
};

PaymentSchedule.propTypes = {
  backgroundColor: PropTypes.string,
  borderColor: PropTypes.string,
  borderRadius: PropTypes.string,
  heading: PropTypes.string.isRequired,
  paymentSchedule: PropTypes.arrayOf(PropTypes.shape({
    amount: PropTypes.number,
    collected: PropTypes.bool,
    collectionDay: PropTypes.string,
    index: PropTypes.number,
    periodEnd: PropTypes.string,
    periodStart: PropTypes.string
  })).isRequired,
  tableHeader1: PropTypes.string,
  tableHeader2: PropTypes.string,
  tableHeader3: PropTypes.string,
  tableHeader4: PropTypes.string
};
var TableSection = styled.section(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  margin: 1rem 0 0 0;\n  padding: 0.5rem;\n  background-color: ", ";\n  border: 0.0625rem solid ", ";\n  border-radius: ", ";\n\n  @media (min-width: 48rem) {\n    padding: 0.5rem 1.5625rem;\n  }\n"])), function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.borderColor;
}, function (props) {
  return props.borderRadius;
});
var Table = styled.table(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n\n  td {\n    border-top: 0.0625rem solid #e5e5e8;\n  }\n\n  td,\n  th {\n    padding: 0 0.625rem;\n    font-size: 0.75rem;\n    text-align: left;\n  }\n\n  td:first-child,\n  th:first-child {\n    padding: 0 0;\n  }\n\n  td:last-child,\n  th:last-child {\n    text-align: right;\n  }\n\n  @media (min-width: 30rem) {\n    td,\n    th {\n      padding: 0 1.25rem;\n      font-size: 1rem;\n    }\n    td:first-child,\n    th:first-child {\n      padding: 0 0;\n    }\n  }\n"])));

var SV_SE = 'sv-SE';

var _templateObject;

var PolicyContent = function PolicyContent(_ref) {
  var answers = _ref.answers,
      _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? 'Försäkringsinnehåll' : _ref$heading,
      _ref$localeStringOpti = _ref.localeStringOptions,
      localeStringOptions = _ref$localeStringOpti === void 0 ? ['sv-SE', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2
  }] : _ref$localeStringOpti,
      nationality = _ref.nationality;
  return /*#__PURE__*/jsxs(LetterSection, {
    children: [/*#__PURE__*/jsx(H2, {
      children: heading
    }), answers.map(function (answer, index) {
      var _answer$value;

      return /*#__PURE__*/jsxs(PolicyItemContainer, {
        children: [/*#__PURE__*/jsxs(LabelText, {
          children: [answer.label, ":"]
        }), answer.dataType === 'currency' && nationality === SV_SE ? /*#__PURE__*/jsxs(ValueText, {
          children: [(_answer$value = answer.value).toLocaleString.apply(_answer$value, _toConsumableArray(localeStringOptions)), " kr"]
        }) : answer.dataType === 'postcode' && nationality === SV_SE ? /*#__PURE__*/jsx(ValueText, {
          children: formatSwedishPostcode(answer.value)
        }) : /*#__PURE__*/jsx(ValueText, {
          children: answer.value
        })]
      }, index);
    })]
  });
};

PolicyContent.propTypes = {
  answers: PropTypes.arrayOf(PropTypes.shape({
    claimFreeYears: PropTypes.string,
    coverLevel: PropTypes.string,
    dwelling: PropTypes.string,
    email: PropTypes.string,
    endDate: PropTypes.string,
    excessLevel: PropTypes.string,
    mileage: PropTypes.string,
    parking: PropTypes.string,
    product: PropTypes.string,
    productVersion: PropTypes.string,
    reference: PropTypes.string,
    registrationNumber: PropTypes.string,
    socialSecurity: PropTypes.string,
    startDate: PropTypes.string,
    telephoneNumber: PropTypes.string,
    youngDriver: PropTypes.string
  })).isRequired,
  localeStringOptions: PropTypes.array,
  premium: PropTypes.shape({
    annual: PropTypes.number,
    day: PropTypes.number,
    monthly: PropTypes.number
  }),
  policyNumber: PropTypes.string
};
var PolicyItemContainer = styled(ItemContainer)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-bottom: 1px solid lightgray;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 2.5rem;\n  font-size: 0.938rem;\n\n  @media (min-width: 26.5rem) {\n    font-size: 1rem;\n  }\n"])));

var PolicyHolder = function PolicyHolder(_ref) {
  var _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? '#fafafa' : _ref$backgroundColor,
      _ref$borderColor = _ref.borderColor,
      borderColor = _ref$borderColor === void 0 ? '#dadada' : _ref$borderColor,
      _ref$borderRadius = _ref.borderRadius,
      borderRadius = _ref$borderRadius === void 0 ? '0.313rem' : _ref$borderRadius,
      firstName = _ref.firstName,
      _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? 'Försäkringstagare' : _ref$heading,
      lastName = _ref.lastName,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? 'Namn' : _ref$label;
  return /*#__PURE__*/jsxs(LetterSection, {
    backgroundColor: backgroundColor,
    borderColor: borderColor,
    borderRadius: borderRadius,
    children: [/*#__PURE__*/jsx(H2, {
      children: heading
    }), PolicyHolder, /*#__PURE__*/jsxs(ItemContainer, {
      children: [/*#__PURE__*/jsxs(LabelText, {
        children: [label, ":"]
      }), /*#__PURE__*/jsxs("p", {
        children: [firstName, " ", lastName]
      })]
    })]
  });
};

PolicyHolder.propTypes = {
  backgroundColor: PropTypes.string,
  borderColor: PropTypes.string,
  borderRadius: PropTypes.string,
  firstName: PropTypes.string.isRequired,
  heading: PropTypes.string,
  label: PropTypes.string,
  lastName: PropTypes.string.isRequired
};

var PolicyTable = function PolicyTable(_ref) {
  var tableContents = _ref.tableContents,
      tableHeadings = _ref.tableHeadings,
      _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? 'Försäkringsskyddets omfattning' : _ref$heading;
  console.log('tableContents', tableContents);
  return /*#__PURE__*/jsxs(LetterSection, {
    children: [/*#__PURE__*/jsx(H2, {
      children: heading
    }), /*#__PURE__*/jsxs(ContentTable, {
      children: [/*#__PURE__*/jsx("thead", {
        children: /*#__PURE__*/jsx("tr", {
          children: tableHeadings.map(function (heading, index) {
            return /*#__PURE__*/jsx(TableHeader, {
              children: heading
            }, index);
          })
        })
      }), /*#__PURE__*/jsx("tbody", {
        children: tableContents.map(function (content, index) {
          return /*#__PURE__*/jsxs("tr", {
            children: [/*#__PURE__*/jsx("td", {
              children: content.label
            }), /*#__PURE__*/jsx("td", {
              children: content.deductible
            }), /*#__PURE__*/jsx("td", {
              children: content.maxCompensation
            })]
          }, index);
        })
      })]
    })]
  });
};

PolicyTable.propTypes = {
  tableContents: PropTypes.array.isRequired,
  tableHeadings: PropTypes.array.isRequired,
  heading: PropTypes.string
};

export { Header, Page, PageWrapper, PaymentSchedule, PolicyContent, PolicyHolder, PolicyTable, SV_SE, styles as Styles };
